const img = require('./puff-geosecma-linkedin_5b7379b94614dde24934c92e27c1ba9c.png').default; export default img;